import React, { useEffect, useState } from "react";
import landing2 from "../assets/PNG/Landing2.png";

import landing2MB from "../assets/PNG/Landing2MB.png";

// import foto3 from "../../src/assets/PNG/blogCard__image1.png";
// import foto4 from "../../src/assets/PNG/imageStatus__1.png";
// import foto5 from "../../src/assets/PNG/blogCard__image2.png";
// import foto6 from "../../src/assets/PNG/blogCard__image3.png";

import slideShow1 from "@/assets/PNG/Group 577.png";
import CardSlideshow from "@/components/LandingPageComponents/CardSlideShow";
import { CardSlideshowMB, InstallPWAButton } from "@/components";
import { getUser } from "@/utils/localStorage.tsx";
import { RoutesPathList } from "@/config/routes/Routes.tsx";
import { NavLink, useNavigate } from "react-router-dom";

const slides = [
  {
    image: slideShow1,
    title: "Where innovation meets crypto",
    text: "Leonext offers full spectrum support to businesses and HNI clients, who want to convert cryptocurrencies to fiat currencies efficiently and quickly. Leonext’s cutting edge technology combined with a user friendly platform makes your crypto conversions easier than ever, ensuring you stay focused on your plans and goals.",
  },
];

const Landing: React.FC = () => {
  const [currentSlide, _setCurrentSlide] = useState(0);

  // const nextSlide = () => {
  //   setCurrentSlide((prevSlide) => (prevSlide + 1) % slides.length);
  // };

  // const prevSlide = () => {
  //   setCurrentSlide(
  //     (prevSlide) => (prevSlide - 1 + slides.length) % slides.length
  //   );
  // };

  const [isMobile, setIsMobile] = useState<boolean>(false);

  const checkIsMobile = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  useEffect(() => {
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, []);

  const userLoggedIn = !!getUser();

  const navigate = useNavigate();

  const handleClick = () => {
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const isInStandaloneMode =
      window.matchMedia("(display-mode: standalone)").matches ||
      (window.navigator as any).standalone === true;

    if (
      userLoggedIn &&
      isInStandaloneMode &&
      location.pathname !== RoutesPathList.NewClientPOS
    ) {
      navigate(RoutesPathList.NewClientPOS);
    } else if (isMobile) {
      navigate(RoutesPathList.POSLogin);
    } else {
      navigate(RoutesPathList.Landing);
    }
  }, [userLoggedIn, navigate]);

  return (
    <div className="landing">
      <div
        className="landing__1"
        style={{ backgroundImage: `url(${slides[currentSlide].image})` }}
      >
        {isMobile ? (
          <button>
            <div></div>
          </button>
        ) : (
          <div></div>
        )}

        <div className="landing__1__content">
          <h1>{slides[currentSlide].title}</h1>
          <p className="pt-[1rem]">{slides[currentSlide].text}</p>
        </div>

        <button>{isMobile ? <div></div> : <div></div>}</button>
      </div>

      <div className="landing__2 px-[13rem] max-[1440px]:px-[5rem]">
        <div className="landing__2__title">Conversion Steps</div>
        <div className="landing__2__steps">
          <div className="landing__2__steps__step">
            <div className="landing__2__steps__step__number">Step 1</div>
            <div className="landing__2__steps__step__title">Registration</div>
            <div className="landing__2__steps__step__text">
              In order to use Leonext’s services, you have to create an account
              with us. Click on the Sign Up button and follow the required
              process to create a Leonext user profile. The 2-factor
              authentication option makes sure that your account will be secure
              at all times.
            </div>
          </div>
          <div className="landing__2__steps__step">
            <div className="landing__2__steps__step__number">Step 2</div>
            <div className="landing__2__steps__step__title">Verification</div>
            <div className="landing__2__steps__step__text">
              Once you create your account, we will ask you to help us verify
              your account details based on a comprehensive streamlined KYC/KYB
              process.
            </div>
          </div>
          <div className="landing__2__steps__step">
            <div className="landing__2__steps__step__number">Step 3</div>
            <div className="landing__2__steps__step__title">Buy & Sell</div>
            <div className="landing__2__steps__step__text">
              Your Leonext account is now active! Log in and convert your
              cryptocurrencies to FIAT or vice versa in just a few minutes.
            </div>
          </div>
        </div>
        <InstallPWAButton
          onInstall={() => {}}
          renderButton={(onClick, disabled) => (
            <button
              className="cursor-pointer landing__2__button"
              onClick={onClick}
              disabled={disabled}
            >
              Download App
            </button>
          )}
        />
      </div>

      <div className="landing__3 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-0">
        {isMobile ? (
          <div className="w-full">
            <img src={landing2MB} alt="photo" />
          </div>
        ) : (
          <img src={landing2} alt="photo" />
        )}
        <div className="landing__3__container">
          <div className="greenline1"></div>
          <div className="landing__3__container__title">
            Explore The Future Of Digital Assets Conversion With Leonext
          </div>
          <div className="landing__3__container__text">
            Cryptocurrencies have revolutionized the payment landscape by
            offering decentralized, borderless, and secure transactions. They
            eliminate intermediaries, reducing transaction fees and processing
            times.
            <br />
            <br />
            Take advantage of fast, secure cryptocurrency conversions, explore
            the broad range of services that Leonext has to offer and stay ahead
            of your competitors.
          </div>
          <div className="landing__3__container__button cursor-pointer">
            <NavLink to="/blog" onClick={handleClick}>
              <div className="landing__3__button">
                {" "}
                {/*//TODO: Add onClick event */}
                See More{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                >
                  <path
                    d="M0 4.46029H9.54638V14L14 9.54786V0H4.46583L0 4.46029Z"
                    fill="#35BCAB"
                  />
                </svg>
              </div>
            </NavLink>
          </div>
        </div>
      </div>

      <div className="landing__4 mb-[1rem] px-[6rem] max-[1440px]:px-[3rem]">
        <div className="landing__4__title px-[1rem] max-[1440px]:px-[2rem] max-[899px]:px-[4rem]">
          Solutions
        </div>
        {isMobile ? <CardSlideshowMB /> : <CardSlideshow />}
      </div>

      {/* <div className="landing__5 w-full mb-[5rem] text-[#050F27]">
        <div className="landing__5__top w-full relative bg-[#FBFBFB] px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-[1rem]">
          <div className="landing__5__top__title">Blog</div>
          <div className="landing__5__top__text">
            Your go-to resource for the latest insights, trends, and news in the
            ever-evolving world of cryptocurrency and fintech.Stay informed
            about what’s next.
          </div>
          <div className="landing__5__greenBar"></div>
        </div>
        <div className="flex justify-between px-[13rem] max-[1440px]:px-[5rem] max-[899px]:flex-col max-[899px]:px-4">
          <BlogCard
            image={foto3}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto5}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />

          <BlogCard
            image={foto6}
            section="News"
            title="Lorem ipsum dolor sit amet, cons ectetur adipiscing elit."
            information="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus pretium a nunc non sodales. Aenean tincidunt mi sit amet egestas mattis. Nulla vel nunc rho"
            imageStatus={foto4}
            name="Gabriel Joshua"
            date="June, 2023"
            button="Read more"
          />
        </div>
      </div>

      <div className="landing__6 px-[13rem] max-[1440px]:px-[5rem] max-[899px]:px-[1rem]">
        <div className="landing__6__container__top">
          <div className="landing__6__container__title">
            What our customers say
          </div>
          <ReviewCard />
          <ReviewCard />
          <ReviewCard />
          <ReviewCard />
        </div>
        {isMobile ? <Fragment /> : <div className="landing__6__greenBar"></div>}
      </div> */}
    </div>
  );
};

export default Landing;
